import PropTypes from 'prop-types';
import {useSelector} from 'react-redux';
import {Link} from 'react-router-dom';
import {Icon} from 'semantic-ui-react';

import {getWsDbSiteManagementLink} from 'state/selectors';

const SiteManagementLink = ({type, projectName, showIcon}) => {
  const wsDbSiteMgmLink = useSelector(getWsDbSiteManagementLink);
  const linkContent = showIcon ? <Icon name="setting" color="black" /> : projectName;
  const renderItem = url => (
    <Link to={url} aria-label="settings">
      {linkContent}
    </Link>
  );

  switch (type) {
    case 'WebeosSite':
    case 'WebeosSite-Playground':
      return renderItem(`/webeos/${projectName}`);
    case 'GitlabPagesSite':
    case 'GitlabPagesSite-Playground':
      return renderItem(`/gps/${projectName}`);
    case 'PaasProject':
    case 'PaasProject-Playground':
      return renderItem(`/paas/${projectName}`);
    case 'DrupalSite':
    case 'DrupalSite-Playground':
      return renderItem(`/drupal/${projectName}`);
    case 'WordpressSite':
    case 'WordpressSite-Playground':
      return renderItem(`/wordpress/${projectName}`);
    case 'AppCatalogue':
    case 'AppCatalogue-Playground':
    case 'GrafanaInstance':
    case 'GrafanaInstance-Playground':
    case 'DiscourseInstance':
    case 'DiscourseInstance-Playground':
    case 'SentryInstance':
    case 'SentryInstance-Playground':
    case 'LegacyWordpressSite':
    case 'LegacyWordpressSite-Playground':
      return renderItem(`/app-catalogue/${projectName}`);
    case 'NexusInstance':
    case 'NexusInstance-Playground':
      return renderItem(`/nexus/${projectName}`);
    case 'AfsGateway':
    case 'IIS7':
    case 'IIS7Dfs2':
    case 'SP2013':
    case 'SPCommunity':
    case 'IIS8Dfs':
    case 'J2EEApp2':
    case 'SP13HNSC':
    case 'EOSGateway':
    case 'Drupal8':
      const url = new URL(wsDbSiteMgmLink);
      url.searchParams.append('SiteName', projectName);

      return (
        <a href={url.toString()} rel="noreferrer" aria-label="settings">
          {linkContent}
        </a>
      );
    default:
      return null;
  }
};

SiteManagementLink.propTypes = {
  type: PropTypes.string.isRequired,
  projectName: PropTypes.string.isRequired,
  showIcon: PropTypes.bool.isRequired,
};

export default SiteManagementLink;
